function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 519.29864,
  width: 1031,
  height: 2,
  fill: "#3f3d56"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 550,
  y: 223.29864,
  width: 384,
  height: 368,
  fill: "#ffc105"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 522,
  y: 590.29864,
  width: 475,
  height: 2,
  fill: "#3f3d56"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 665.81687,
  y: 359.98831,
  width: 110.15278,
  height: 128.33333,
  fill: "#f2f2f2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M903.24743,614.40457h-154v-154h154Zm-151.86111-2.13889H901.10854V462.54346H751.38632Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#3f3d56"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 696.83076,
  y: 380.30776,
  width: 94.11111,
  height: 2.13889,
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 696.83076,
  y: 403.83554,
  width: 94.11111,
  height: 2.13889,
  fill: "#3f3d56"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 696.83076,
  y: 427.36331,
  width: 94.11111,
  height: 2.13889,
  fill: "#3f3d56"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 440.45361,
  y: 74.29864,
  width: 457.54639,
  height: 2,
  fill: "#3f3d56"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 96,
  y: 403.29864,
  width: 251,
  height: 2,
  fill: "#3f3d56"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 157.29864,
  width: 361,
  height: 223,
  fill: "#ffc105"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 61,
  y: 225.13322,
  width: 222,
  height: 110.16541,
  fill: "#f2f2f2"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M412.5,461.31211h-268v-134h268Zm-266-2h264v-130h-264Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#3f3d56"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 100.03076,
  y: 258.21563,
  width: 143.93848,
  height: 2,
  fill: "#3f3d56"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 100.03076,
  y: 279.21563,
  width: 143.93848,
  height: 2,
  fill: "#3f3d56"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 100.03076,
  y: 300.21563,
  width: 143.93848,
  height: 2,
  fill: "#3f3d56"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M551.74461,277.91212C540.1377,258.3,517.17434,257.386,517.17434,257.386s-22.37648-2.86148-36.73085,27.008c-13.37942,27.84079-31.84473,54.72165-2.97276,61.239l5.21511-16.23177,3.22969,17.4402a112.96671,112.96671,0,0,0,12.35324.21113c30.91954-.99827,60.36573.29206,59.4176-10.80317C556.426,321.49982,562.9128,296.78287,551.74461,277.91212Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#2f2e41"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M509.94532,314.84593s15,21,6,38,21,35,21,35l22-48s-26-17-19-33Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#fbbebe"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 435.44532,
  cy: 172.83246,
  r: 26,
  fill: "#fbbebe"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M429.96583,327.90179l21.728-28.03376s7.6506-29.38483,18.73125-27.89516-4.3766,35.23982-4.3766,35.23982l-21.58945,31.03056Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#fbbebe"
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  points: "455.445 575.832 462.445 612.832 477.445 616.832 473.445 572.832 455.445 575.832",
  fill: "#fbbebe"
});

var _ref23 = /*#__PURE__*/React.createElement("polygon", {
  points: "606.445 535.832 633.445 572.832 644.445 577.832 653.445 562.832 626.445 527.832 606.445 535.832",
  fill: "#fbbebe"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M533.94532,371.84593l-16.6811-21.95933s-32.3189,5.95933-35.3189,8.95933,8,58,8,58,2,15,11,23l9,6,74-15,2.78246-32.9258A86.41011,86.41011,0,0,0,563.94535,331.846l0,0-12.8758,1.76022Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#575a89"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M485.94532,360.84593l-5-2-23-2s-8-2-6-6,4-5,0-6-5-2-4-5,7-9,7-9l-17-14s-.9201.65081-2.4073,1.85491c-8.44043,6.83376-35.1472,31.48943-15.5927,56.14509,23,29,50,46,72,40Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#575a89"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M507.94532,440.84593v14s-9,17-6,33,4,24,4,24a136.53331,136.53331,0,0,0,7,40c7,20-16,151,13,153s45,4,54-6-15-182-15-182,82,171,99,164,60-23,55-32-131-209-131-209l-4-9Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#2f2e41"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M555.94532,730.84593s-16-1-16,4-8,22-8,22-6,20,10,18,26-20,26-20l-4-19Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#2f2e41"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M722.94532,695.84593s-14-9-13-3,2,22,9,23,28,7,29,9,25,10,25-3-15-23-15-23l-17-13s-11-1-13,6S722.94532,695.84593,722.94532,695.84593Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#2f2e41"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 435.48482,
  cy: 132.47187,
  r: 16.60376,
  fill: "#2f2e41"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M501.63329,253.11593a16.6044,16.6044,0,0,1,14.856-16.51042,16.77219,16.77219,0,0,0-1.74776-.09334,16.60377,16.60377,0,1,0,0,33.20753,16.77219,16.77219,0,0,0,1.74776-.09334A16.60441,16.60441,0,0,1,501.63329,253.11593Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#2f2e41"
});

var _ref31 = /*#__PURE__*/React.createElement("polygon", {
  points: "462.113 151.008 439.426 139.125 408.097 143.986 401.615 172.614 417.751 171.994 422.258 161.476 422.258 171.821 429.703 171.534 434.025 154.789 436.726 172.614 463.193 172.074 462.113 151.008",
  fill: "#2f2e41"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M545.25456,443.16266l-34.98722.94591s-29.85391,5.809-28.17895-6.24071,30.79949-7.83525,30.79949-7.83525l31.88021-4.86338Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#fbbebe"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M572.93658,330.1508a7.46667,7.46667,0,0,1,8.23586,5.128c6.84947,21.584,27.95077,93.81336,6.98533,103.72285-24.69358,11.67164-42.714,11.15847-42.714,11.15847l-9.64534-23.748,8.78051-8.24031,9.37441-60.27537,4.492-25.55049Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#575a89"
});

var _ref34 = /*#__PURE__*/React.createElement("polygon", {
  points: "481.945 245.332 477.945 285.332 442.945 300.332 481.945 291.332 481.945 245.332",
  opacity: 0.4
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M345.86686,610.08626c-5.68507,21.01543-25.15771,34.03082-25.15771,34.03082s-10.25533-21.05736-4.57026-42.07279,25.15771-34.03081,25.15771-34.03081S351.55193,589.07083,345.86686,610.08626Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#ffc105"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M294.14859,610.08626c5.68507,21.01543,25.15771,34.03082,25.15771,34.03082s10.25533-21.05736,4.57026-42.07279-25.15771-34.03081-25.15771-34.03081S288.46352,589.07083,294.14859,610.08626Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#ffc105"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M302.5024,605.56982c15.59991,15.18589,17.50533,38.53012,17.50533,38.53012s-23.387-1.27694-38.98695-16.46282S263.51545,589.107,263.51545,589.107,286.90249,590.38394,302.5024,605.56982Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#3f3d56"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M337.51305,605.56982c-15.59991,15.18589-17.50532,38.53012-17.50532,38.53012s23.387-1.27694,38.98694-16.46282S376.5,589.107,376.5,589.107,353.113,590.38394,337.51305,605.56982Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#3f3d56"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M774.86686,167.08626c-5.68507,21.01543-25.15771,34.03082-25.15771,34.03082s-10.25533-21.05736-4.57026-42.07279,25.15771-34.03081,25.15771-34.03081S780.55193,146.07083,774.86686,167.08626Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#ffc105"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M723.14859,167.08626c5.68507,21.01543,25.15771,34.03082,25.15771,34.03082s10.25533-21.05736,4.57026-42.07279-25.15771-34.03081-25.15771-34.03081S717.46352,146.07083,723.14859,167.08626Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#ffc105"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M731.5024,162.56982c15.59991,15.18589,17.50533,38.53012,17.50533,38.53012s-23.387-1.27694-38.987-16.46282S692.51545,146.107,692.51545,146.107,715.90249,147.38394,731.5024,162.56982Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#3f3d56"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M766.51305,162.56982c-15.59991,15.18589-17.50532,38.53012-17.50532,38.53012s23.387-1.27694,38.98694-16.46282S805.5,146.107,805.5,146.107,782.113,147.38394,766.51305,162.56982Z",
  transform: "translate(-84.5 -125.01348)",
  fill: "#3f3d56"
});

function SvgNlp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a52ce8ac-7708-4c6b-8f08-fc4d288bf8bf",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1031,
    height: 649.97305,
    viewBox: "0 0 1031 649.97305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "static_page") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlp);
export default __webpack_public_path__ + "static/media/nlp.555b08ca.svg";
export { ForwardRef as ReactComponent };